import {
  PDFIcon,
  SVGFileIcon,
  JPGFileIcon,
  JSFiledIcon,
  PNGFileIcon,
  PPTFileIcon,
  TIFFFIleIcon,
  TXTFileIcon,
  WordFileIcon,
  RawFileIcon,
  MarkDownFileIcon,
  ExcelFileIcon,
} from '.';

export const fileTypeToIconMap: Record<string, JSX.Element> = {
  pdf: <PDFIcon />,
  md: <MarkDownFileIcon />,
  txt: <TXTFileIcon />,
  tiff: <TIFFFIleIcon />,
  raw: <RawFileIcon />,
  png: <PNGFileIcon />,
  jpg: <JPGFileIcon />,
  jpeg: <JPGFileIcon />,
  js: <JSFiledIcon />,
  docx: <WordFileIcon />,
  xls: <ExcelFileIcon />,
  xlsx: <ExcelFileIcon />,
  ppt: <PPTFileIcon />,
  svg: <SVGFileIcon />,
  'text/plain': <TXTFileIcon />,
  'application/msword': <WordFileIcon />,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': (
    <WordFileIcon />
  ),
  'application/pdf': <PDFIcon />,
};
